import React from 'react';
import { useSelector } from 'react-redux';

const ResultsInfo = () => {
    //Tomo el store
    const audience = useSelector(state => state.audiences.audienceWork);
    //Renderizo
    return (
        <div className="col-12">
            <div className="card shadow mb-4">
                <div className="card-header py-2 d-flex flex-row align-items-center justify-content-between">
                    <h6 className="m-0 font-weight-bold text-primary">RESULTADOS AUDIENCIA</h6>
                </div>
                <div className="card-body">
                    <div className="row no-gutters align-items-center">
                        <div className="col mr-2">
                            <div className={`text-xs font-weight-bold text-${ audience.estado.css } text-uppercase mb-1`}>
                                { audience.estado.descripcion }
                            </div>
                            <div className="h5 mb-0 font-weight-bold text-gray-800">
                                <div className="row">
                                    <div className="col-12 mb-1">
                                        <small>Resultado/s:</small>
                                        &nbsp;
                                        {
                                            audience.resultadoList.map((result, index) => (
                                                index === 0 ? result.descripcion : `, ${result.descripcion}`
                                            ))
                                        }
                                    </div>
                                    {
                                        audience.observacion ? (
                                            <div className="col-12 mb-1">
                                                <small>Observaciones:</small>
                                                <br/>
                                                {
                                                    audience.observacion
                                                }
                                            </div>
                                        ) : null
                                    }
                                </div>
                            </div>
                        </div>
                        <div className="col-auto">
                            <i className="fas fa-info-circle fa-2x text-gray-300"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ResultsInfo;